export default __webpack_public_path__ + "static/media/lineto-circular-bold.f817e60d.woff2";